import { VuexModule, Module, Mutation, getModule, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import api from '@/api'
import store from '.'
import { ColumnsTypes } from './columnsTypes'

export interface ISortColumnState {
    showSortColumnDialog: boolean;
    sortColumnDialogTableName: string;
    tableColumnsObj: any;
    tableColumnsObjCopy: any;
}

const originalSortColumnObj: any = {}
_.cloneDeep(ColumnsTypes).forEach(val => {
    const tableColumnsObj = {}
    val.tableColumnsList.forEach((item, key) => {
        const columnName: any = item.columnName
        item.index = key
        delete item.columnName
        tableColumnsObj[columnName] = item
    })
    originalSortColumnObj[val.tableName] = tableColumnsObj
})

const tableColumnsObj = _.cloneDeep(originalSortColumnObj)

const tableColumnsObjCopy = _.cloneDeep(originalSortColumnObj)

/**
 * showSortColumnDialog 控制顶层dialog显示和隐藏
 *
 * tableColumnsObj 是前端需要自己维护的表格列项对象
 *
 * sortColumnDialogTableName 是具体的表格名字，需注意该名字要与表格ref名保持一致！！！。
 */
@Module({ dynamic: true, namespaced: true, store, name: 'tableColumns' })
class SortColumn extends VuexModule implements ISortColumnState {
    public showSortColumnTable: Element|null = null;

    public showSortColumnDialog: boolean = false;

    public sortColumnDialogTableName: string = '';

    public tableColumnsObj: any = tableColumnsObj;

    public originalSortColumnObj: any = originalSortColumnObj;

    public tableColumnsObjCopy: any = tableColumnsObjCopy;

    @Mutation
    public CLOSE_SORT_COLUMNS_DLG() {
        this.showSortColumnDialog = false
    }

    @Mutation
    public OPEN_SORT_COLUMNS_DLG(table) {
        this.showSortColumnDialog = true
        this.showSortColumnTable = table
        // 打开时进行备份，一直操作备份，点ok更新，cancel按钮只负责关闭弹窗
        this.tableColumnsObjCopy[this.sortColumnDialogTableName] = _.cloneDeep(this.tableColumnsObj[this.sortColumnDialogTableName])
    }

    @Mutation
    public SAVE_TABLE_NAME(tableName) {
        this.sortColumnDialogTableName = tableName
    }

    @Mutation
    public CHANGE_CHECKED_STATUS(payload) {
        const { name, label } = payload
        this.tableColumnsObjCopy[name][label].checked = !this.tableColumnsObjCopy[name][label].checked
    }

    @Mutation
    public RESTORE_DEFAULT_SETTINGS() {
        this.tableColumnsObjCopy[this.sortColumnDialogTableName] = _.cloneDeep(this.originalSortColumnObj[this.sortColumnDialogTableName])
    }

    @Mutation
    public UPDATE_COLUMNS_STATE(params) {
        const updatedObj = params.updatedObj
        const tableName = params.tableName || this.sortColumnDialogTableName
        if (!updatedObj) return
        const newColumns: string[] = []
        const config = this.tableColumnsObj[tableName]
        const configKeys = Object.keys(config)
        configKeys.forEach(key => {
            if (updatedObj[key]) {
                config[key].checked = updatedObj[key].checked
                config[key].index = updatedObj[key].index
            } else {
                newColumns.push(key) // 收集新增的列项
            }
        })
        newColumns.forEach(item => {
            configKeys.forEach(key => {
                if (!newColumns.includes(key) && config[key].index >= config[item].index) { // 找到所有index大于等于新列项的列项，将其index+1，保证新列项位于其index的位置，且整个table的index不出现重复
                    config[key].index++
                }
            })
        })
    }

    @Mutation
    public DEFAULT_DATA(tableName) {
        this.tableColumnsObj[tableName] = _.cloneDeep(this.originalSortColumnObj[tableName])
        this.tableColumnsObjCopy[tableName] = _.cloneDeep(this.tableColumnsObj[tableName])
    }

    @Action({ rawError: true })
    public async GET_TABLE_COLUMNS_CONFIG(tableName) {
        const res = await api.get_table_filters_config({filterTableName: tableName})
        this.SAVE_TABLE_NAME(tableName)
        if (!res.data || res.data === 'Default Config Constant') return // 默认配置常量 则无需重新赋值
        this.UPDATE_COLUMNS_STATE({ updatedObj: JSON.parse(res.data), tableName })
    }
}

export const TableColumnsModule = getModule(SortColumn)
